import { BaseError } from '@dynamic-labs-sdk/client';

export class NotAptosProviderError extends BaseError {
  public readonly providerKey: string;

  constructor(params: { providerKey: string }) {
    super({
      cause: null,
      code: 'not_aptos_provider_error',
      docsUrl: null,
      name: 'NotAptosProviderError',
      shortMessage: 'Provider is not an Aptos wallet provider',
    });

    this.providerKey = params.providerKey;
  }
}
